'use client';

import React, { createContext, useContext } from 'react';

const NonceContext = createContext<string | undefined>(undefined);

export const NonceProvider = ({
    nonce,
    children,
}: {
    nonce: string;
    children: React.ReactNode;
}) => {
    return (
        <NonceContext.Provider value={nonce}>{children}</NonceContext.Provider>
    );
};

export const useNonce = () => {
    const context = useContext(NonceContext);
    // It's possible to use it outside provider (e.g. tests), so be gentle
    return context || '';
};
